<template>
  <section class="sub_contents_wrap container">
    <div class="brick_box">
      <div class="view_top">
        <div class="view_title">{{ qna.title }}</div>
        <ul class="view_info">
          <li class="view_user">{{ qna.firstRegrName }}</li>
          <li class="view_date">{{ qna.firstRegDatetime }}</li>
        </ul>
        <div class="view_file" v-if="files.length > 0 && files != null">
          <ul>
            <li>
              <span>File</span>
              <a
                v-for="(file, index) in files"
                :key="index"
                href="#"
                @click="downloadFile(file)"
              >
                {{ file.fileNm }}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="qna.content" v-html="qna.content" class="view_t"></div>

      <!------- 답글 시작 -------------------->
      <div style="margine-left: 10px" v-for="(answer, index) in answers" :key="index">
        <div v-if="answer.parent == answer.groupId" class="view_answer_box">
          <div class="view_top">
            <div class="va_top">
              <p>
                <strong>{{ answer.title }}</strong>
              </p>
              <div class="list_bottom_bt">
                <a
                  v-if="$session.get('loginUser') == answer.firstRegrId"
                  @click="deleteAnswer(answer)"
                  class="btn btn-secondary btn-sm m-1"
                  >{{ $t("common.delete") }}</a
                >
                <button
                  v-if="$session.get('loginUser') == answer.firstRegrId"
                  @click="goToEdit(answer)"
                  class="btn btn-primary btn-sm m-1"
                >
                  {{ $t("common.edit") }}
                </button>
                <button
                  @click="addAnswer(answer, index)"
                  class="btn btn-primary btn-sm m-1"
                >
                  {{ $t("common.reply") }}
                </button>
              </div>
            </div>
            <ul class="view_info">
              <li class="view_user">{{ answer.firstRegrName }}</li>
              <li class="view_date">{{ answer.firstRegDatetime }}</li>
            </ul>
            <div
              class="view_file"
              v-if="answer.fileList.length > 0 && answer.fileList != null"
            >
              <ul>
                <li>
                  <span>File</span>
                  <a
                    v-for="(file, index) in answer.fileList"
                    :key="index"
                    href="#"
                    @click="downloadFile(file)"
                  >
                    {{ file.fileNm }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div v-html="answer.content" class="view_t"></div>
        </div>
        <!-- 답글의 답글일 경우  -->
        <div
          v-else
          class="view_answer_box"
          :style="{ 'padding-left': 40 * answer.depth + 'px' }"
        >
          <div class="view_top">
            <div class="va_top">
              <p>
                <strong>{{ answer.title }}</strong>
              </p>
              <div class="list_bottom_bt">
                <a
                  v-if="$session.get('loginUser') == answer.firstRegrId"
                  @click="deleteAnswer(answer)"
                  class="btn btn-secondary btn-sm m-1"
                  >{{ $t("common.delete") }}</a
                >
                <button
                  v-if="$session.get('loginUser') == answer.firstRegrId"
                  @click="goToEdit(answer)"
                  class="btn btn-primary btn-sm m-1"
                >
                  {{ $t("common.edit") }}
                </button>
                <button
                  @click="addAnswer(answer, index)"
                  class="btn btn-primary btn-sm m-1"
                >
                  {{ $t("common.reply") }}
                </button>
              </div>
            </div>
            <ul class="view_info">
              <li class="view_user">{{ answer.firstRegrName }}</li>
              <li class="view_date">{{ answer.firstRegDatetime }}</li>
            </ul>
            <div
              class="view_file"
              v-if="answer.fileList.length > 0 && answer.fileList != null"
            >
              <ul>
                <li>
                  <span>File</span>
                  <a
                    v-for="(file, index) in answer.fileList"
                    :key="index"
                    href="#"
                    @click="downloadFile(file)"
                  >
                    {{ file.fileNm }}
                  </a>
                  <!-- <span v-for="(file, index) in answer.fileList" :key="index" href="#">
                    <a v-if="file.boardId == answer.boardId" @click="downloadFile(file)">
                      {{ file.fileNm }}
                    </a>
                  </span> -->
                </li>
              </ul>
            </div>
          </div>
          <div v-html="answer.content" class="view_t"></div>
        </div>
      </div>
    </div>
    <!-----------------새로운 답변 Form ---------------------->
    <div v-if="addNewAnswer" class="brick_box">
      <table class="write_tbl">
        <tbody>
          <tr>
            <th>{{ $t("common.title") }}</th>
            <td>
              <input
                type="text"
                v-model="newAnswer.title"
                v-validate="'required'"
                class="form-control text"
                ref="{search}"
              />
            </td>
          </tr>
          <tr>
            <th>{{ $t("common.file") }}</th>
            <td>
              <uploader
                :options="options"
                class="uploader-example"
                :autoStart="false"
                :size="10"
                @file-added="filesAdded"
                @file-removed="fileRemoved"
              >
                <uploader-unsupport></uploader-unsupport>
                <uploader-drop>
                  <uploader-btn>Select or drag&drop file</uploader-btn>
                </uploader-drop>
                <uploader-list></uploader-list>
              </uploader>
              <div
                class="view_file"
                v-if="newAnswer.fileList.length > 0 && newAnswer.fileList != null"
              >
                <ul>
                  <li>
                    <span>File</span>
                    <a
                      v-for="(file, index) in newAnswer.fileList"
                      :key="index"
                      href="#"
                      @click="downloadFile(file)"
                    >
                      {{ file.fileNm }}
                    </a>
                  </li>
                </ul>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <ckeditor
                name="answerContent"
                v-model="newAnswer.content"
                :config="editorConfig"
                v-validate="'required'"
              ></ckeditor>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="text-right">
        <button
          type="button"
          @click="addNewAnswer = false"
          class="btn btn-secondary btn-md m-1"
        >
          {{ $t("common.cancel") }}
        </button>
        <button type="button" @click="saveAnswer" class="btn btn-primary btn-md m-1">
          {{ $t("common.save") }}
        </button>
      </div>
    </div>
    <div class="list_bottom_bt">
      <!-- v-if="$session.get('loginUser') == qna.firstRegrId" -->
      <!-- 질문글에 답글을 달 경우에는 seq 가 다름 -->
      <a
        v-if="$session.get('loginUser') == qna.firstRegrId"
        @click="deleteQna(qna)"
        class="btn btn-secondary btn-lg m-1"
        >{{ $t("common.delete") }}</a
      >
      <router-link
        v-if="$session.get('loginUser') == qna.firstRegrId"
        :to="{ name: 'qnaForm', params: { boardId: qna.boardId } }"
        class="btn btn-primary btn-lg m-1"
        >{{ $t("common.edit") }}</router-link
      >
      <button @click="addAnswer(qna)" class="btn btn-primary btn-lg m-1">
        {{ $t("common.writeAnswer") }}
      </button>
      <router-link :to="{ name: 'qnaList' }" class="btn btn-outline-dark btn-lg m-1">{{
        $t("common.list")
      }}</router-link>
    </div>
  </section>
</template>

<script>
import { goDownloadFile } from "@/api/file";
import { getQna, deleteQna, insertQna, deleteQnaAnswer } from "@/api/qna";

export default {
  data() {
    return {
      id: "",
      qna: {
        boardId: "",
        fileList: [],
        title: "",
        content: "",
        attributeName: "",
        firstRegDatetime: "",
        firstRegrId: "",
      },
      editorConfig: {
        filebrowserImageUploadUrl: "/img/fileupload",
        filebrowserUploadMethod: "form",
      },
      options: {
        testChunks: false,
        chunkSize: "10", //Block size
        maxChunkRetries: 3,
      },
      files: [],
      boardId: "",
      confirmYn: false,
      answers: [],
      answerFiles: [],
      addNewAnswer: false,
      newAnswer: {
        boardId: "",
        fileList: [],
        title: "",
        content: "",
        attributeName: "",
        firstRegDatetime: "",
        parent: "",
        step: "",
        groupId: "",
        flag: "I",
        seq: 0,
      },
      newFiles: [],
      refuseFileType: [
        "asp",
        "aspx",
        "jsp",
        "php",
        "inc",
        "cgi",
        "html",
        "htm",
        "js",
        "jar",
        "jhtml",
        "php3",
        "phtml",
      ],
      seq: 0,
      index: 0,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    /* 새로운 답글 초기화 */
    resetNewQna() {
      this.newAnswer.boardId = "";
      this.newAnswer.fileList = [];
      this.newAnswer.title = "";
      this.newAnswer.content = "";
      this.newAnswer.flag = "I";
      this.newAnswer.fileList = [];
      this.newFiles = [];
    },
    resetQnaData() {
      this.qna = "";
      this.files = "";
      this.answers = "";
    },
    /* init */
    async fetchData() {
      // qna list 불러오기 검색시 동일
      try {
        this.boardId = this.$route.query.boardId;
        const { data } = await getQna(this.boardId);
        this.qna = data.qna;
        this.files = data.files;
        this.answers = data.answers;
        // seq 세팅
        if (this.answers != null && this.answers.length > 0) {
          this.seq = this.answers[this.answers.length - 1].seq;
          this.newAnswer.seq = parseInt(this.seq) + 1;
        } else {
          this.newAnswer.seq = 0;
        }
      } catch (err) {
        console.log(err);
      }
    },
    /* 새로운 답글 추가 */
    addAnswer(parent, index) {
      this.index = index;
      this.newAnswer.title = "Re: " + parent.title;
      this.newAnswer.groupId = parent.groupId;
      this.newAnswer.parent = parent.boardId;
      this.newAnswer.step = parent.step;
      this.newAnswer.seq = parseInt(parent.seq) + 1;
      // 답글의 답글일 경우
      if (parent.depth != null) {
        this.newAnswer.depth = parseInt(parent.depth) + 1;
        // 질문글에대한 답글일 경우
      } else {
        this.newAnswer.seq = parseInt(this.seq) + 1;
        this.newAnswer.depth = 1;
      }
      // 1. 답글중 parent 가 같고 depth 가 같고 하위 depth 가 없을 경우 해당 seq 에서 +1
      // 2.depth 가 있을경우 => 해당 index 이후의 for 체크후 동일한 depth 가진 데이터가 있다면 그 seq 에서 +1
      for (let i = 0; i < this.answers.length; i++) {
        if (
          this.newAnswer.parent == this.answers[i].parent &&
          this.newAnswer.depth == this.answers[i].depth
        ) {
          // depth 체크
          let depth = this.answers[i].depth;
          let tmpSeq = this.answers[i].seq;
          this.newAnswer.seq = parseInt(tmpSeq) + 1;
          for (let j = i + 1; j < this.answers.length; j++) {
            // depth가 다음보다 작거나 같다면
            if (parseInt(depth) <= parseInt(this.answers[j].depth)) {
              let tmpSeq = this.answers[j].seq;
              this.newAnswer.seq = parseInt(tmpSeq) + 1;
            } else {
              break;
            }
          }
          break;
        }
      }
      this.addNewAnswer = true;
      window.scrollTo(0, document.body.scrollHeight);
    },
    /* 답변 저장 */
    async saveAnswer() {
      const validForm = await this.$validator.validateAll();
      if (!validForm) return alert(this.$t("alert.plzCheckAllValues"));
      try {
        const formData = new FormData();
        console.log(this.newAnswer.seq);
        formData.append("boardId", this.newAnswer.boardId);
        formData.append("parent", this.newAnswer.parent);
        formData.append("seq", this.newAnswer.seq);
        formData.append("title", this.newAnswer.title);
        formData.append("flag", this.newAnswer.flag);
        formData.append("groupId", this.newAnswer.groupId);
        formData.append("step", this.newAnswer.step);
        formData.append("depth", this.newAnswer.depth);
        if (this.newAnswer.answerContent != null) {
          formData.append("content", this.newAnswer.content);
        } else {
          formData.append("content", this.newAnswer.content);
        }
        if (this.newFiles != null && this.newFiles != "") {
          for (var i = 0; i < this.newFiles.length; i++) {
            let file = this.newFiles[i];
            formData.append("qnaFiles", file);
          }
        }
        // 답변저장
        const { data } = await insertQna(formData);
        // seq update
        this.resetNewQna();
        // const response = updateAnswerSeq(this.answers);
        if (data.fileMessage != undefined && data.message != null) {
          alert(this.$t("alert.ThisIsNotAnAllowedFile"));
        } else if (data.fileMessage == undefined && data.message != null) {
          alert(this.$t("alert.plzCheckAllValues"));
        }
        if (data.status) {
          this.resetQnaData();
          this.fetchData();
        } else {
          alert(this.$t("alert.ErrorPlzcontactManager"));
        }
      } catch (err) {
        console.log(err);
      }

      this.addNewAnswer = false;
    },
    /* 질문글 삭제 */
    async deleteQna() {
      if (this.answers != null && this.answers.length > 0) {
        alert(this.$t("alert.itCantNotBeDeleted"));
        return;
      }
      this.confirmYn = confirm(this.$t("alert.delete"));
      if (this.confirmYn) {
        try {
          this.qna.boardId = this.boardId;
          this.qna.fileList = this.files;
          const { data } = await deleteQna(this.qna);
          if (data.status) {
            alert(this.$t("alert.deletedSuccessfully"));
            this.$router.push({ name: "qnaList" });
          } else {
            alert(this.$t("alert.ErrorPlzcontactManager"));
          }
        } catch (err) {
          console.log(err);
        }
      }
    },
    /* 답글 수정 */
    goToEdit(answer) {
      this.newAnswer = answer;
      this.newAnswer.flag = "U";
      // this.newFiles = answer.fileList;
      this.addNewAnswer = true;
    },
    /* 답글 삭제 */
    async deleteAnswer(answer) {
      // child answer 확인
      for (let i = 0; i < this.answers.length; i++) {
        if (answer.boardId == this.answers[i].parent) {
          alert(this.$t("alert.itCantNotBeDeleted"));
          return;
        }
      }
      this.confirmYn = confirm(this.$t("alert.delete"));
      if (this.confirmYn) {
        try {
          const { data } = await deleteQnaAnswer(answer);
          if (data.status) {
            alert(this.$t("alert.deletedSuccessfully"));
            this.fetchData();
          } else {
            alert(this.$t("alert.ErrorPlzcontactManager"));
          }
        } catch (err) {
          console.log(err);
        }
      }
    },
    /* 파일 추가 */
    filesAdded(file) {
      let tmp = file.file.name;
      let fileName = tmp.split(".");
      // 파일 확장자 확인
      for (let i in this.refuseFileType) {
        if (fileName[fileName.length - 1] == this.refuseFileType[i]) {
          alert(this.$t("alert.ThisIsNotAnAllowedFile"));
          file.ignored = true;
          return;
        }
      }
      this.newFiles.push(file.file);
    },
    /* 파일 삭제 */
    fileRemoved(file) {
      if (this.newFiles.length > 0) {
        for (let i = 0; i < this.newFiles.length; i++) {
          if (this.newFiles[i].name == file.file.name) {
            this.$delete(this.newFiles, i);
          }
        }
      }
    },
    /* 파일 다운로드 */
    async downloadFile(file) {
      try {
        const res = await goDownloadFile(file.fileId);
        let data = res.data;
        if (!data) {
          return;
        }
        const blob = new Blob([data]);
        if (window.navigator.msSaveOrOpenBlob) {
          // compatible IE10
          navigator.msSaveBlob(blob, file.fileId);
        } else {
          // IE core support other non-H5 browsers
          let url = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", file.fileNm);
          document.body.appendChild(link);
          link.click();
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style></style>
